import { Injectable } from '@angular/core';

import { Row } from '@app/classes/row.class';
import { Filters } from '@app/classes/table.class';
import { environment } from 'environments/environment';
import { Service as ServiceAPI } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class Service {
    private base_url = environment.api;
    private api_type = (environment.api_type == 'php')? '.php' : '';
    private base_endpoint = (environment.api_version == 'v1')? 'app_settings/application/' : 'app_settings/';
    
    constructor(
        private ServiceAPI: ServiceAPI,
	) { }

    async get(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get.php' : data.item_id),  'get'); }
    async save(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : ''), 'post'); }
    async update(data: any, item_id: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : data.item_id), 'put'); }
    async getList(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_list.php' : ''), 'get'); }
    async getPair(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_pair.php' : 'get_pair'), 'get'); }
	async getProfile(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get_profile.php' : `get_profile/${data.item_id}`),  'get'); }
    async changeActive(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_active.php' : `change_active/${data.item_id}`), 'put'); }
    async changeLocked(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_locked.php' : `change_locked/${data.item_id}`), 'put'); }
    async changeDeleted(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_deleted.php' : data.item_id), 'delete'); }
	async downloadListCSV(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'download_list_csv.php' : ''),  'get'); }
}

export interface FiltersAppSettings extends Filters {
    app_settings_id?:number;
    name?:string;
    label?:string;
    type?:string;
    private?:string;
    [key: string]: any;
}

export class AppSettings extends Row {
    constructor(){
        super();
    }

    public override init(){
        super.init();
        this.data = {
            app_settings:{},
            pager:{
                next:0,
                previous:0
            }
        };
    }
}